import React, { useState, useEffect } from "react";
import { getFirestore, collection, addDoc, getDocs, where, query } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const Classroom = () => {
  const [customMaterials, setCustomMaterials] = useState([]);
  const [newMaterial, setNewMaterial] = useState({ title: "", description: "", video: "", music: "", game: "" });
  const [user, setUser] = useState(null);
  const db = getFirestore();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        fetchCustomMaterials(currentUser);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const fetchCustomMaterials = async (currentUser) => {
    if (!currentUser) return;
    
    const q = query(collection(db, "customMaterials"), where("educatorId", "==", currentUser.uid));
    const querySnapshot = await getDocs(q);
    const materials = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    
    setCustomMaterials(materials);
  };

  const handleAddMaterial = async () => {
    if (!user) {
      alert("User not authenticated.");
      return;
    }

    const newEntry = { ...newMaterial, educatorId: user.uid, educatorCode: user.educatorCode, grade: user.grade };
    await addDoc(collection(db, "customMaterials"), newEntry);
    
    setNewMaterial({ title: "", description: "", video: "", music: "", game: "" });
    fetchCustomMaterials(user);
  };

  return (
    <div style={styles.container}>
      <h1>Your Classroom</h1>

      {/* Form to Add Custom Material */}
      <div style={styles.formContainer}>
        <h3>Add Custom Material</h3>
        <input type="text" placeholder="Title" value={newMaterial.title} onChange={(e) => setNewMaterial({ ...newMaterial, title: e.target.value })} />
        <textarea placeholder="Description" value={newMaterial.description} onChange={(e) => setNewMaterial({ ...newMaterial, description: e.target.value })} />
        <input type="text" placeholder="Video URL" value={newMaterial.video} onChange={(e) => setNewMaterial({ ...newMaterial, video: e.target.value })} />
        <input type="text" placeholder="Music URL" value={newMaterial.music} onChange={(e) => setNewMaterial({ ...newMaterial, music: e.target.value })} />
        <input type="text" placeholder="Game URL" value={newMaterial.game} onChange={(e) => setNewMaterial({ ...newMaterial, game: e.target.value })} />
        <button onClick={handleAddMaterial}>Add Material</button>
      </div>

      {/* Display Educator's Custom Materials */}
      <div style={styles.materialsContainer}>
        <h2>Your Custom Materials</h2>
        {customMaterials.length === 0 ? <p>No custom materials added yet.</p> : (
          customMaterials.map((material) => (
            <div key={material.id} style={styles.materialCard}>
              <h3>{material.title}</h3>
              <p>{material.description}</p>
              <a href={material.video} target="_blank" rel="noopener noreferrer">Watch Video</a> |
              <a href={material.music} target="_blank" rel="noopener noreferrer"> Listen to Music</a> |
              <a href={material.game} target="_blank" rel="noopener noreferrer">Play Game</a>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { padding: "20px", textAlign: "center" },
  formContainer: { marginBottom: "20px" },
  materialsContainer: { marginTop: "20px" },
  materialCard: { backgroundColor: "#f3f3f3", padding: "15px", margin: "10px", borderRadius: "5px" },
};

export default Classroom;
